import Generator from '../../../../Generator'
import Types from '../../../../../actions/Types'

export default Generator.node({
  baseType: Types.CONTROLS,
  nodeType: Generator.NODETYPE.GET,
  suffixType: 'FULL'
})



// WEBPACK FOOTER //
// ./src/reducers/root/entities/controls/get/full.js